module.exports = __webpack_public_path__ + "assets/img/cricket-argentina.4e19093f.jpg";